import { getEnvironmentLabel, isProd } from '@/shared/lib/util/environment';
import { theme } from '@/shared/styles';
import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { Body1 } from './Typography';

export const ENVIRONMENT_BAR_HEIGHT = 30;

const EnvironmentBar = () => {
  const [info, setInfo] = useState({ label: '', isProd: false });

  useEffect(() => {
    const label = getEnvironmentLabel();

    setInfo({ label, isProd: isProd() });
  }, []);

  return (
    <Stack
      sx={{
        display: !info.isProd ? 'flex' : 'none',
        userSelect: 'none',
        zIndex: theme.zIndex.drawer + 2,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        // Set by AppFrame's top banners (new release, mock company) when one is showing, so this drops below it
        // instead of sitting underneath it at the literal top of the viewport -- otherwise the
        // two fixed-position elements overlapped and this pill was mostly hidden behind the
        // banner, or the reverse, with either arrangement covering the other.
        top: 'var(--top-banner-height, 0px)',
        left: '50%',
        transform: 'translate(-50%, 0)',
        transition: 'top 0.15s ease',
        height: `${ENVIRONMENT_BAR_HEIGHT}px`,
        backgroundColor: theme.palette.error.dark,
        padding: 1,
        minWidth: '100px',
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px'
      }}
    >
      <Body1 sx={{ color: theme.palette.error.contrastText, textAlign: 'center' }}>{info.label}</Body1>
    </Stack>
  );
};

export default EnvironmentBar;
